import React from 'react'
import {
	Drawer,
	Row,
	Space,
	Typography,
	List,
	Tag,
	Popconfirm
} from 'antd'
import { CloseOutlined, PlusOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { IOtherPriceOffer } from '../../../reducers/priceOffers/actions'
import { DEFAULT_DATE_WITH_TIME_FORMAT, translatePriceOfferStatusColor, translatePriceOfferStatusToSk } from '../../../utils/enums'

interface OtherPriceOffersDrawerProps {
	otherPriceOffers: IOtherPriceOffer[]
	currentPriceOfferId: number | null
	open: boolean
	onClose: () => void
	onCreateNew: () => void
	onSelect: (id: number) => void
	createDisabled: boolean
}

const OtherPriceOffersDrawer: React.FC<OtherPriceOffersDrawerProps> = ({
	otherPriceOffers, currentPriceOfferId, open, onClose, onCreateNew, onSelect, createDisabled
}) => (
	<Drawer
		title={
			<Row justify="space-between" align="middle">
				<Space>
					<CloseOutlined style={{ color: '#aaa' }} onClick={onClose} />
					<Typography.Text strong>Ostatné cenové ponuky</Typography.Text>
				</Space>
				<Popconfirm
					title="Naozaj chcete duplikovať cenovú ponuku?"
					icon={<QuestionCircleOutlined style={{ color: 'blue' }} />}
					cancelText="Zrušiť"
					okText="Duplikovať"
					onConfirm={(e) => {
						e?.stopPropagation()
						onCreateNew()
					}}
					onCancel={(e) => e?.stopPropagation()}
					disabled={createDisabled}
				>
					<PlusOutlined
						style={createDisabled ? { opacity: 0.4, cursor: 'not-allowed' } : { cursor: 'pointer' }}
					/>
				</Popconfirm>
			</Row>
		}
		width={600}
		visible={open}
		onClose={onClose}
		closeIcon={null}
	>
		<List
			itemLayout="vertical"
			dataSource={otherPriceOffers}
			renderItem={(item) => {
				const isCurrent = Number(item.id) === Number(currentPriceOfferId)
				return (
					<List.Item
						key={item.id}
						onClick={() => { if (!isCurrent) { onSelect(item.id) } }}
						style={{
							cursor: isCurrent ? 'default' : 'pointer',
							border: isCurrent ? '1px solid #fa8c16' : undefined,
							borderRadius: isCurrent ? 6 : undefined,
							padding: isCurrent ? '8px 12px' : undefined
						}}
					>
						<Row justify="space-between" align="middle">
							<Space>
								<Tag color={translatePriceOfferStatusColor(item.status)}>
									{translatePriceOfferStatusToSk(item.status)}
								</Tag>
								{isCurrent && <Tag color={'orange'}>Aktuálna</Tag>}
								<Typography.Text type="secondary">
									{dayjs(item.createdAt).format(DEFAULT_DATE_WITH_TIME_FORMAT)}
								</Typography.Text>
							</Space>
							<Typography.Text strong>{item.price} €</Typography.Text>
						</Row>
						<div style={{ marginTop: 8 }}>
							<Typography.Text type="secondary">
								Autor: {item.authorName || '-'}
							</Typography.Text>
						</div>
					</List.Item>
				)
			}}
		/>
	</Drawer>
)

export default OtherPriceOffersDrawer
